import { makeStyles, createStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    formControl: {
      minWidth: 200
    },
    clearFilters: {
      marginRight: '10px'
    },
    centerButton: {
      display: 'flex',
      justifyContent: 'center', // Center horizontally
      alignItems: 'center', // Center vertically
      height: '100%' // Make sure the container takes up full height of the Grid item
    },
    tableContainer: {
      maxHeight: '400px'
    }
  })
)
